module.exports = __webpack_public_path__ + "89b4e140e274877239236c5618faf37d.png";